"use strict";

exports.__esModule = true;
exports.toolsCardPropTypes = exports["default"] = exports.PanelImage = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ramda = require("ramda");

var _styles = require("@qc-modules/styles");

var _utils = require("../../utils");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

var _excluded = ["isFlipped"],
    _excluded2 = ["isFlipped"],
    _excluded3 = ["isFlipped"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var toolsCardPropTypes = {
  /** Card back an array of React components  */
  cardBack: _propTypes.node,

  /** onClick handler */
  clickHandler: _propTypes.func,

  /** Color style prop  */
  color: _utils.stylePropType,

  /** Columns array for grid  */
  columns: (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])),

  /** Description text usually a text, but can be a React component  */
  description: _propTypes.node,

  /** Image source */
  imageAbove: _propTypes.node,

  /** Image source */
  imageBelow: _propTypes.node,

  /** Index passed to clickHandler */
  index: _propTypes.number,

  /** Boolean to rotate card */
  isFlipped: _propTypes.bool,

  /** Boolean determines card styles */
  single: _propTypes.bool,

  /** Title text usually a text, but can be a React component  */
  title: _propTypes.node,

  /** Title color style prop */
  titleColor: _utils.stylePropType
};
exports.toolsCardPropTypes = toolsCardPropTypes;
var defaultProps = {
  color: "text",
  isFlipped: false,
  titleColor: "text-hover"
};
var ItemContainer = (0, _styledComponents["default"])(function (_ref) {
  var isFlipped = _ref.isFlipped,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, props);
}).withConfig({
  displayName: "card__ItemContainer",
  componentId: "sc-p3h5nh-0"
})(["perspective:1200px;position:relative;transform-style:preserve-3d;&:hover{transform:", ";}", ";"], function (_ref2) {
  var isFlipped = _ref2.isFlipped;
  return isFlipped ? "" : "translateY(-4px)";
}, (0, _styles.transitionEase)("0.7s", ["transform"]));
var DropShadow = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "card__DropShadow",
  componentId: "sc-p3h5nh-1"
})(["border-radius:8px;position:absolute;left:0;right:0;height:100%;top:0;", ";opacity:0;box-shadow:0 8px 16px ", ";", ":hover &{opacity:1;box-shadow:0 8px 16px ", ";}"], (0, _styles.transitionEase)("0.7s", ["box-shadow", "opacity"]), function (props) {
  return (0, _styles.themeTransparentize)(1, "border")(props);
}, ItemContainer, function (props) {
  return (0, _styles.themeTransparentize)(0.2, "border")(props);
});
var ItemFront = (0, _styledComponents["default"])(function (_ref3) {
  var isFlipped = _ref3.isFlipped,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded2);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, props);
}).withConfig({
  displayName: "card__ItemFront",
  componentId: "sc-p3h5nh-2"
})(["border-radius:8px;cursor:pointer;", ";background-color:", ";box-shadow:0 4px 16px 0 ", ",0 2px 4px 0 ", ";", ":hover &{box-shadow:0 0 24px ", ";}transform-style:preserve-3d;backface-visibility:hidden;position:relative;z-index:1;transform:", ";transform-origin:50% 50%;"], (0, _styles.transitionEase)("0.7s", ["box-shadow", "transform"]), function (props) {
  return (0, _styles.colors)("background", props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.92, "background-dark")(props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.84, "background-dark")(props);
}, ItemContainer, function (props) {
  return (0, _styles.themeTransparentize)(0.5, "border")(props);
}, function (_ref4) {
  var isFlipped = _ref4.isFlipped;
  return isFlipped ? "rotateY(-180deg)" : "rotateY(0deg)";
}); // WARNING MVP hacks below. ENG to provide updated data types for card back

var ItemBack = (0, _styledComponents["default"])(function (_ref5) {
  var isFlipped = _ref5.isFlipped,
      props = _objectWithoutPropertiesLoose(_ref5, _excluded3);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, props);
}).withConfig({
  displayName: "card__ItemBack",
  componentId: "sc-p3h5nh-3"
})(["color:", ";position:absolute;left:0;top:0;", ";border-radius:8px;background-color:", ";box-shadow:0 4px 16px 0 ", ",0 2px 4px 0 ", ";&:hover{box-shadow:0 0 24px ", ";}transform-style:preserve-3d;backface-visibility:hidden;transform-origin:50% 50%;z-index:0;transform:", ";min-height:100%;"], function (props) {
  return (0, _styles.colors)("text-light", props);
}, (0, _styles.transitionEase)("0.7s", ["box-shadow", "transform"]), function (props) {
  return (0, _styles.colors)("background-dark", props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.92, "background-dark")(props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.84, "background-dark")(props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.5, "border")(props);
}, function (_ref6) {
  var isFlipped = _ref6.isFlipped;
  return isFlipped ? "rotateY(0deg)" : "rotateY(180deg)";
});
var CardTitle = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "card__CardTitle",
  componentId: "sc-p3h5nh-4"
})(["letter-spacing:0.3px;", " ", ":hover &{color:", ";}"], (0, _styles.defaultTransition)(["color"]), ItemFront, function (props) {
  return (0, _styles.themeDarken)(0.15, props.color, props);
});
var PanelImage = (0, _styledComponents["default"])(_primitives["default"].Image).withConfig({
  displayName: "card__PanelImage",
  componentId: "sc-p3h5nh-5"
})(["max-width:100%;"]);
exports.PanelImage = PanelImage;
var CategoryContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "card__CategoryContainer",
  componentId: "sc-p3h5nh-6"
})(["max-width:100%;"]);
var FlexImage = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "card__FlexImage",
  componentId: "sc-p3h5nh-7"
})(["flex:0 0 auto;"]);

function findClosest(event, tag) {
  var el = event.target;

  if (!document.documentElement.contains(el)) {
    return null;
  }

  do {
    if (el.tagName.toLowerCase() === tag) {
      return el;
    }

    el = el.parentElement || el.parentNode;
  } while (el !== null && el.nodeType === 1);

  return null;
}

var ToolsCard = function ToolsCard(_ref7) {
  var cardBack = _ref7.cardBack,
      clickHandler = _ref7.clickHandler,
      color = _ref7.color,
      columns = _ref7.columns,
      description = _ref7.description,
      title = _ref7.title,
      index = _ref7.index,
      isFlipped = _ref7.isFlipped,
      imageAbove = _ref7.imageAbove,
      single = _ref7.single,
      titleColor = _ref7.titleColor;
  var descriptionFont = {
    color: color,
    fontSize: 3,
    fontWeight: 1,
    letterSpacing: "0.5px",
    lineHeight: 3,
    textAlign: "left"
  };
  var titleFont = {
    color: titleColor,
    fontSize: 5,
    fontWeight: 2,
    lineHeight: "1.3",
    mb: 3,
    textAlign: "left"
  }; // Again we need more controll - MVP styles

  var cardBackWrap = single ? "wrap" : "nowrap";
  var cardBackContentWidth = single ? [1, 1 / 3, 1 / 3, 1] : 1;
  return /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, {
    alignItems: "flex-start",
    columns: columns,
    height: 1,
    justifyContent: "flex-start",
    onClick: function onClick(event) {
      event.stopPropagation();

      if (findClosest(event, "a") === null) {
        clickHandler(isFlipped ? null : index);
      }
    },
    pb: 3,
    width: single ? 1 : "auto"
  }, /*#__PURE__*/_react["default"].createElement(ItemContainer, {
    height: 1,
    isFlipped: isFlipped,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(ItemFront, {
    alignItems: "center",
    flexDirection: single ? ["column", "row"] : "column",
    height: 1,
    isFlipped: isFlipped,
    justifyContent: single ? ["flex-start", "center"] : "flex-start",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(DropShadow, null), /*#__PURE__*/_react["default"].createElement(FlexImage, {
    alignItems: "flex-start",
    justifyContent: "center",
    mb: single ? [0, 5] : 0,
    ml: single ? [0, 5] : 0,
    mt: 5
  }, imageAbove && ((0, _ramda.is)(String, imageAbove) ? /*#__PURE__*/_react["default"].createElement(PanelImage, {
    mb: 2,
    src: imageAbove
  }) : /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    mb: 2
  }, imageAbove))), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "flex-start",
    flexDirection: "column",
    justifyContent: "center",
    mx: single ? [0, 5] : 0,
    my: 5,
    px: single ? [3, 0] : [3, 3, 3, 2],
    width: 1
  }, title && /*#__PURE__*/_react["default"].createElement(CardTitle, _extends({
    tag: "h2",
    textAlign: "center",
    width: 1
  }, titleFont), title), description && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    tag: "div",
    textAlign: "center",
    width: 1
  }, descriptionFont), description))), /*#__PURE__*/_react["default"].createElement(ItemBack, {
    flexDirection: "column",
    height: 1,
    isFlipped: isFlipped,
    px: 2,
    py: 4,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(CategoryContainer, {
    alignItems: "flex-start",
    flexDirection: "column",
    flexWrap: cardBackWrap,
    width: cardBackContentWidth
  }, cardBack))));
};

ToolsCard.propTypes = toolsCardPropTypes;
ToolsCard.defaultProps = defaultProps;
ToolsCard.displayName = "Modules.ToolsCard";

var _default = (0, _styledComponents.withTheme)(ToolsCard);

exports["default"] = _default;